/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';

export const userFixedAlertSchema = z.object({
  beachWithExperienceAlertActive: z.boolean(),
  clientCreatedAccountAlertActive: z.boolean(),
  clientCreatedOppAlertActive: z.boolean(),
  clientReqInterviewAlertActive: z.boolean(),
  clientSearchedInAfcAlertActive: z.boolean(),
  clientSignedInAlertActive: z.boolean(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  talentSelectedOnOppAlertActive: z.boolean(),
  updatedAt: z.string().datetime().nullish(),
  userId: z.string().uuid().nullish(),
  waitlistWithExperienceAlertActive: z.boolean(),
});

export type UserFixedAlert = z.infer<typeof userFixedAlertSchema>;
